const SAMPLE_FETCH_TIMEOUT_MS = 10_000;

export const SYNTHETIC_RETURN_SAMPLE = {
  key: 'return_2024',
  label: 'Synthetic 2024 Form 1040',
  filename: '2024_Form_1040_Return_Sample.pdf',
  path: '/samples/Tax-Return.pdf',
} as const;

export interface SampleDocumentSource {
  path: string;
  filename: string;
}

function readBlobText(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
}

export async function fetchSamplePdf({
  path,
  filename,
}: SampleDocumentSource): Promise<File> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(
    () => controller.abort(),
    SAMPLE_FETCH_TIMEOUT_MS
  );

  try {
    const response = await fetch(path, { signal: controller.signal });
    if (!response.ok)
      throw new Error(`Sample request failed: ${response.status}`);

    const blob = await response.blob();
    if (blob.type.toLowerCase() !== 'application/pdf') {
      throw new Error(`Unexpected sample content type: ${blob.type}`);
    }
    if ((await readBlobText(blob.slice(0, 5))) !== '%PDF-') {
      throw new Error('Unexpected sample file signature');
    }

    return new File([blob], filename, { type: 'application/pdf' });
  } finally {
    window.clearTimeout(timeoutId);
  }
}
